/* Nordvale 3D — one fixed WebGL particle field behind the whole store.
   Plain WebGL, no library. The particles follow the page:
     hero      NORDVALE wordmark → the three hero products, rebuilt from their own photos in true colour
     content   they burst into a spiral vortex you fly through as you scroll
     the end   they pull back together into the NORDVALE wordmark
   Pages without the hero start in the vortex. Motion is time-based (same feel
   at 60 and 120 Hz), layout is measured once, not on every scroll, and quality
   drops automatically if a device can't keep up.

   Markup hooks:
     [data-nv3d]       tall hero that drives the first four shapes
     [data-nv3d-step]  one text panel per hero shape (4)
     [data-nv3d-end]   the closing section where the wordmark re-forms */
(function () {
  var hero = document.querySelector('[data-nv3d]');            // the product stories (sticky scroll steps)
  var intro = document.querySelector('[data-nv3d-intro]');      // one-screen intro with the NORDVALE wordmark
  var endEl = document.querySelector('[data-nv3d-end]');
  var steps = [].slice.call(document.querySelectorAll('[data-nv3d-intro] [data-nv3d-step], [data-nv3d] [data-nv3d-step]'));
  var canvas = document.createElement('canvas');
  canvas.className = 'nv-sky'; canvas.setAttribute('aria-hidden', 'true');
  var gl = canvas.getContext('webgl', { antialias: false, alpha: true, powerPreference: 'high-performance' });
  var html = document.documentElement;
  if (!gl) { html.classList.add('nv-nogl'); if (hero) hero.classList.add('nv3d-off'); return; }
  document.body.insertBefore(canvas, document.body.firstChild);

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var small = Math.min(window.innerWidth, window.innerHeight) < 700;
  var touch = window.matchMedia('(hover: none)').matches;
  var N = small ? 9000 : 22000;   // shape particles
  var S = small ? 220 : 420;      // stars

  /* ---------- shapes (each fills N points) ---------- */
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function put(o, k, x, y, z) { o[k * 3] = x; o[k * 3 + 1] = y; o[k * 3 + 2] = z; }

  function logo(fontFamily) {
    var c = document.createElement('canvas'), W = 1400, H = 340;
    c.width = W; c.height = H;
    var x = c.getContext('2d');
    x.fillStyle = '#fff'; x.textAlign = 'center'; x.textBaseline = 'middle';
    x.font = '300px ' + fontFamily;
    x.fillText('NORDVALE', W / 2, H / 2 + 14);
    var d = x.getImageData(0, 0, W, H).data, pts = [];
    for (var y = 0; y < H; y += 2) for (var i = 0; i < W; i += 2) if (d[(y * W + i) * 4 + 3] > 140) pts.push(i, y);
    var out = new Float32Array(N * 3), s = 6.4 / W;
    for (var k = 0; k < N; k++) {
      var j = (Math.random() * (pts.length / 2) | 0) * 2;
      put(out, k, (pts[j] - W / 2) * s + rnd(-.008, .008), -(pts[j + 1] - H / 2) * s + rnd(-.008, .008), rnd(-.16, .16));
    }
    return out;
  }
  /* Self-contained so it can run in a Worker: page loads never block while 100k points are built. */
  function shapeKit(N) {
    function rnd(a, b) { return a + Math.random() * (b - a); }
    function gauss() { return (Math.random() + Math.random() + Math.random() - 1.5) / 1.5; }
    function put(o, k, x, y, z) { o[k * 3] = x; o[k * 3 + 1] = y; o[k * 3 + 2] = z; }
    function seg(o, k, a, b, j) { var t = Math.random(); put(o, k, a[0] + (b[0] - a[0]) * t + rnd(-j, j), a[1] + (b[1] - a[1]) * t + rnd(-j, j), a[2] + (b[2] - a[2]) * t + rnd(-j, j)); }
    function ring(o, k, r, y, j) { var a = Math.random() * 6.2832; put(o, k, Math.cos(a) * r + rnd(-j, j), y + rnd(-j, j), Math.sin(a) * r + rnd(-j, j)); }
    function pick(parts) { var r = Math.random(), s = 0; for (var i = 0; i < parts.length; i++) { s += parts[i]; if (r < s) return i; } return parts.length - 1; }
    function vacuum() {                       // robot vacuum: disc, LiDAR turret, bumper, side brushes, floor ripple
      var o = new Float32Array(N * 3), R = 1.55, h = .34, top = h / 2, bot = -h / 2;
      for (var k = 0; k < N; k++) {
        var a = Math.random() * 6.2832;
        switch (pick([.36, .18, .06, .14, .10, .08, .08])) {
          case 0: var rr = Math.random() < .55 ? [.42, .85, 1.25][Math.random() * 3 | 0] + gauss() * .02 : R * Math.sqrt(Math.random());
            put(o, k, Math.cos(a) * rr, top, Math.sin(a) * rr); break;                                        // top face + rings
          case 1: put(o, k, Math.cos(a) * R, rnd(bot, top), Math.sin(a) * R); break;                          // side wall
          case 2: ring(o, k, R * .96, bot, .01); break;                                                        // base rim
          case 3: var ta = Math.random() * 6.2832, tr = Math.random() < .7 ? .36 : .36 * Math.sqrt(Math.random()), ty = Math.random() < .7 ? rnd(top, top + .2) : top + .2;
            put(o, k, Math.cos(ta) * tr, ty, -.55 + Math.sin(ta) * tr); break;                                // LiDAR turret
          case 4: var ba = rnd(-1.25, 1.25) + 1.5708; put(o, k, Math.cos(ba) * (R + .05), rnd(bot, top * .5), Math.sin(ba) * (R + .05)); break; // front bumper
          case 5: var side = Math.random() < .5 ? -1 : 1, sp = (Math.random() * 3 | 0) * 2.094 + side * .4, L = Math.random() * .55;
            put(o, k, side * .95 + Math.cos(sp) * L, bot - .03, .95 + Math.sin(sp) * L); break;              // side brushes
          default: ring(o, k, rnd(1.85, 2.5), bot - .05, .01);                                                 // floor ripple
        }
      }
      return o;
    }
    function table() {                         // round coffee table: marble top with veins, gold cage legs, lower shelf
      var o = new Float32Array(N * 3), T = .75, Rt = 1.8, Rs = 1.3, B = -1.25;
      var veins = []; for (var v = 0; v < 7; v++) veins.push([rnd(-1.4, 1.4), rnd(0, 6.28), rnd(.8, 2.2), rnd(.15, .45)]);
      for (var k = 0; k < N; k++) {
        switch (pick([.20, .08, .12, .14, .34, .12])) {
          case 0: var a = Math.random() * 6.2832, r = Rt * Math.sqrt(Math.random()); put(o, k, Math.cos(a) * r, T, Math.sin(a) * r); break; // marble top
          case 1: var vv = veins[Math.random() * 7 | 0], x = rnd(-Rt, Rt), z = vv[0] + Math.sin(x * vv[2] + vv[1]) * vv[3];
            if (x * x + z * z < Rt * Rt) { put(o, k, x, T + .005, z); break; } k--; break;                    // veins
          case 2: ring(o, k, Rt, rnd(T - .12, T), .005); break;                                               // top edge
          case 3: var sa = Math.random() * 6.2832, sr = Rs * Math.sqrt(Math.random()); put(o, k, Math.cos(sa) * sr, -.95, Math.sin(sa) * sr); break; // lower shelf
          case 4: var leg = Math.random() * 6 | 0, t = Math.random(), a0 = leg * 1.0472, u = 1 - t;      // curved gold legs (quadratic Bézier)
            var ang = a0 + .9 * t, rad = u * u * 1.7 + 2 * u * t * 2.15 + t * t * 1.2, y = u * u * (T - .1) + 2 * u * t * -.1 + t * t * B;
            put(o, k, Math.cos(ang) * rad + gauss() * .02, y, Math.sin(ang) * rad + gauss() * .02); break;
          default: ring(o, k, 1.2, B, .015);                                                                   // base ring
        }
      }
      return o;
    }
    function rack() {                          // shoe rack: slanted tiers, side frames, pairs of shoes
      var o = new Float32Array(N * 3), W = 1.6, D = .45, tiers = [-1.45, -.55, .35, 1.25];
      for (var k = 0; k < N; k++) {
        var p = pick([.24, .14, .07, .55]);
        if (p === 0) { var ty = tiers[Math.random() * 4 | 0], back = Math.random() < .5; seg(o, k, [-W, ty + (back ? .2 : 0), back ? -D : D], [W, ty + (back ? .2 : 0), back ? -D : D], .015); }
        else if (p === 1) { var px = Math.random() < .5 ? -W : W, pz = Math.random() < .5 ? -D : D; seg(o, k, [px, -1.8, pz], [px, 1.6, pz], .015); }
        else if (p === 2) { var cx = Math.random() < .5 ? -W : W, cy = tiers[Math.random() * 4 | 0]; seg(o, k, [cx, cy, D], [cx, cy + .2, -D], .012); }
        else {                                // a shoe = half ellipsoid upper + flat sole, angled with the tier
          var tier = Math.random() * 3 | 0, slot = Math.random() * 4 | 0, foot = Math.random() < .5 ? -1 : 1;
          var bx = -1.12 + slot * .75 + foot * .15, by = tiers[tier] + .1, th = Math.acos(rnd(0, 1)), ph = Math.random() * 6.2832;
          var sx = Math.sin(th) * Math.cos(ph) * .13, sz = Math.sin(th) * Math.sin(ph) * .4, sy = Math.cos(th) * .24;
          if (Math.random() < .25) { sy = 0; sx *= Math.random(); sz *= Math.random(); }
          if (sz < -.1) sy *= 1.6;          // taller heel
          put(o, k, bx + sx, by + sy - sz * .22, sz);
        }
      }
      return o;
    }
    function vortex() {                         // spiral tunnel along z; the middle stays clear for the page content
      var o = new Float32Array(N * 3);
      for (var k = 0; k < N; k++) {
        var z = rnd(-5, 5), arm = k % 3, dust = Math.random() < .12;
        var a = dust ? Math.random() * 6.2832 : arm * 2.094 + z * .55 + gauss() * .2;
        var r = dust ? rnd(1.3, 6) : 1.5 + Math.pow(Math.random(), 1.6) * 4.2;
        put(o, k, Math.cos(a) * r, Math.sin(a) * r * .78, z);
      }
      return o;
    }

    return { vacuum: vacuum, table: table, rack: rack, vortex: vortex };
  }
  function buildShapes(names) {
    return new Promise(function (resolve) {
      function local() { var k = shapeKit(N), o = {}; names.forEach(function (n) { o[n] = k[n](); }); resolve(o); }
      try {
        var src = 'var shapeKit=' + shapeKit.toString() + ';onmessage=function(e){var k=shapeKit(e.data.N),o={};e.data.names.forEach(function(n){o[n]=k[n]()});postMessage(o,e.data.names.map(function(n){return o[n].buffer}))}';
        var url = URL.createObjectURL(new Blob([src], { type: 'text/javascript' })), w = new Worker(url);
        w.onmessage = function (e) { resolve(e.data); w.terminate(); URL.revokeObjectURL(url); };
        w.onerror = function () { w.terminate(); local(); };
        w.postMessage({ N: N, names: names });
      } catch (err) { local(); }
    });
  }

  function loadPhotos(onShape) {
    var urls = steps.slice(1, 4).map(function (s) { return s.getAttribute('data-nv3d-img'); });
    var depths = steps.slice(1, 4).map(function (s) { return parseFloat(s.getAttribute('data-nv3d-depth')) || 1; });
    var cuts = steps.slice(1, 4).map(function (s) { var v = (s.getAttribute('data-nv3d-cut') || '').split(',').map(Number); return (v.length === 4 || v.length === 5) && v.every(isFinite) ? v : null; });
    if (!urls.some(Boolean) || !window.Worker || !window.nvPhotoKit) return;
    var wk;
    try { wk = new Worker(URL.createObjectURL(new Blob(['(' + window.nvPhotoKit.toString() + ')()'], { type: 'text/javascript' }))); } catch (err) { return; }
    wk.onmessage = function (e) {
      var m = e.data;
      if (m.pos) { onShape(m.slot, m.pos, m.col, m.kind); return; }
      if (!m.need) return;
      var img = new Image(); img.crossOrigin = 'anonymous';       // older Safari: decode here, sample in the worker
      img.onload = function () {
        var k = Math.min(1, 360 / Math.max(img.width, img.height)), W = Math.round(img.width * k), H = Math.round(img.height * k);
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H; var x = cv.getContext('2d'); x.drawImage(img, 0, 0, W, H);
        try { var px = x.getImageData(0, 0, W, H).data; wk.postMessage({ slot: m.slot, kind: m.kind, pixels: px.buffer, W: W, H: H, N: N, cut: cuts[m.slot - 1], depth: depths[m.slot - 1] }, [px.buffer]); } catch (err) {}
      };
      img.src = urls[m.slot - 1];
    };
    urls.forEach(function (u, i) { if (u) wk.postMessage({ slot: i + 1, url: new URL(u, location.href).href, N: N, cut: cuts[i], depth: depths[i] }); });
  }

  /* ---------- GL ---------- */
  var VS = [
    'attribute vec3 p0;attribute vec3 p1;attribute vec3 p2;attribute vec3 p3;attribute vec3 p4;attribute vec4 r;attribute vec4 col;attribute vec3 pe;',
    'uniform vec4 w;uniform float wt;uniform float burst;uniform float time;uniform mat3 rot;uniform float aspect;uniform float dpr;',
    'uniform float psz;uniform float warp;uniform float scale;uniform vec2 shift;uniform float travel;uniform float gain;uniform vec2 mouse;uniform float hover;uniform vec3 shock;uniform vec3 mv;uniform float open;uniform vec3 ofs;uniform float flatm;uniform float ex;',
    'varying vec3 vCol;varying float vA;varying float vBlur;',
    'vec3 unpk(float v){return vec3(floor(v/65536.),mod(floor(v/256.),256.),mod(v,256.))/255.;}',
    'void main(){',
    ' vec3 v=p4; v.z=mod(p4.z-travel+5.,10.)-5.;',                                   // fly through the vortex
    ' float sw=time*.05+travel*.22; float c=cos(sw),s=sin(sw); v.xy=mat2(c,s,-s,c)*v.xy;',
    ' vec3 p=p0*w.x+p1*w.y+p2*w.z+p3*w.w+v*wt;',
    ' p+=(r.xyz-.5)*burst*3.4;',
    ' p+=vec3(sin(time*.45+r.w*40.+p.y*2.),cos(time*.38+r.x*30.+p.x*2.),sin(time*.3+r.y*20.))*.022;',
    ' float om=open*ex;p=mix(p,pe,om)+(r.xyz-.5)*sin(3.1416*om)*.9;',               // morph into the exploded render
    ' float lay=mix(clamp(floor(p.y/1.17+.5),-1.,1.),floor(r.x*3.)-1.,flatm);p.xz*=1.-abs(lay)*open*.06*flatm;',   // flat: stacked plates; upright: top, middle, base
    ' p=rot*p*scale;',
    ' p+=ofs*lay*open*(1.-ex)*scale;',                                                         // open: layers part like an exploded diagram
    ' p.z-=warp*6.;p.xy*=1.+warp*.25;',                                              // hyperspace warp on navigation
    ' float z=p.z+7.;',
    ' vec2 q=vec2(p.x/(z*.36*aspect),p.y/(z*.36))+shift;',
    ' vec2 dm=(mouse-q)*vec2(aspect,1.);float pull=hover*exp(-dot(dm,dm)*9.);',          // resting cursor slowly gathers nearby dots
    ' q+=(mouse-q)*pull*.32;',
    ' float wake=exp(-dot(dm,dm)*7.)*mv.z;q+=mv.xy*wake*.045;',                       // dots ripple along the cursor's path
    ' float lens=exp(-dot(dm,dm)*18.)*mv.z;q-=(mouse-q)*lens*.14;',                    // soft lens swells under the cursor
    ' vec2 ds=(q-shock.xy)*vec2(aspect,1.);float sd=length(ds);',                      // click shockwave
    ' float bd=(sd-shock.z*1.7)*7.;float band=exp(-bd*bd)*exp(-shock.z*1.6);',
    ' q+=normalize(ds+1e-5)*band*.09/vec2(aspect,1.);',
    ' gl_Position=vec4(q,0.,1.);',
    ' float blur=clamp((abs(z-7.)-1.6)*.2,0.,1.);',                                         // depth of field
    ' gl_PointSize=min((1.9+r.w*2.6)*psz*dpr*(7./z)*(1.+blur*1.3)*(1.+lens*.5),22.*dpr);',
    ' float fade=smoothstep(1.4,3.,z)*smoothstep(13.,9.5,z)*mix(1.,smoothstep(5.,3.8,abs(v.z)),wt);',
    ' vec3 c3=vec3(1.)*(w.x+wt)+unpk(col.x)*w.y+unpk(col.y)*w.z+unpk(col.z)*w.w;c3=mix(c3,unpk(col.w),om);',
    ' vCol=(c3*.96+.03)*clamp(1.1-(z-7.)*.2,.7,1.2)*(1.+lens*.2)+pull*.25+wake*.06;vBlur=blur;',
    ' vCol=mix(vCol,vec3(.62,.82,1.)*(.7+.5*r.w),open*(1.-ex)*(1.-abs(lay))*.6);',            // the inside glows
    ' vA=((.7+.3*r.w)*(.85+.15*sin(time*2.4+r.y*60.))*fade/(1.+blur*1.3)+band*1.4)*gain;',
    '}'].join('\n');
  var FS = [
    'precision mediump float;varying vec3 vCol;varying float vA;varying float vBlur;',
    'void main(){float d=length(gl_PointCoord-.5)*2.;if(d>1.)discard;',
    ' float a=exp(-d*d*mix(4.5,2.,vBlur))*(1.-smoothstep(.75,1.,d))+smoothstep(.3,0.,d)*(1.-vBlur)*.5;',
    ' a=min(a*vA*1.3,1.);gl_FragColor=vec4(vCol*a,a);}'].join('\n');
  // constellation lines between the resting cursor and the dots it has gathered
  var GVS = 'attribute vec2 a;uniform vec2 c;uniform vec2 rad;varying vec2 v;void main(){v=a;gl_Position=vec4(c+a*rad,0.,1.);}';
  var GFS = 'precision mediump float;varying vec2 v;uniform float str;void main(){float d=length(v);vec3 g=vec3(.80,.85,.93)*exp(-d*d*3.)*(1.-smoothstep(.8,1.,d))*str;gl_FragColor=vec4(g,0.);}';
  var LVS = 'attribute vec3 l;varying float vA;void main(){gl_Position=vec4(l.xy,0.,1.);vA=l.z;}';
  var LFS = 'precision mediump float;varying float vA;void main(){gl_FragColor=vec4(vec3(.9,.95,1.)*vA,vA);}';
  // stars: points, plus streaks whose length follows scroll speed
  var SVS = [
    'attribute vec4 s;uniform float time;uniform float dpr;uniform float scroll;uniform float vel;varying float vA;',
    'void main(){float y=mod(s.y+scroll*(.15+s.z*.6)+1.,2.)-1.;y-=s.w*vel*(.2+s.z);',
    ' gl_Position=vec4(s.x,y,0.,1.);gl_PointSize=(.7+s.z*1.8)*dpr;',
    ' vA=(.1+.38*s.z*(.6+.4*sin(time*1.3+s.x*50.)))*(s.w>0.?clamp(abs(vel)*6.,0.,.9):1.);}'].join('\n');
  var SFS = 'precision mediump float;varying float vA;void main(){gl_FragColor=vec4(vec3(.88,.91,.96)*vA,vA);}';

  function prog(v, f) {
    function sh(t, s) { var o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); return o; }
    var p = gl.createProgram(); gl.attachShader(p, sh(gl.VERTEX_SHADER, v)); gl.attachShader(p, sh(gl.FRAGMENT_SHADER, f)); gl.linkProgram(p);
    if (!gl.getProgramParameter(p, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(p));
    return p;
  }
  function buf(data) { var b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b); gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW); return b; }
  var LOC = {};
  function attr(p, name, b, size) { var key = (p === P ? 'P' : p === SP ? 'S' : p === GP ? 'G' : 'L') + name, l = LOC[key]; if (l === undefined) l = LOC[key] = gl.getAttribLocation(p, name); if (l < 0) return; gl.bindBuffer(gl.ARRAY_BUFFER, b); gl.enableVertexAttribArray(l); gl.vertexAttribPointer(l, size, gl.FLOAT, false, 0, 0); }

  var GP, GB, GU, P, SP, LP, B = {}, starPts, starLines, lineBuf, U = {}, SU = {}, COL = null, K = 700, cand = null;
  var LMAX = 40, lineData = new Float32Array(LMAX * 6);
  var shapes = null, CPU = [];
  function setup(fam) {
    P = prog(VS, FS); SP = prog(SVS, SFS); LP = prog(LVS, LFS); GP = prog(GVS, GFS);
    GB = buf(new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1])); GU = { c: gl.getUniformLocation(GP, 'c'), rad: gl.getUniformLocation(GP, 'rad'), str: gl.getUniformLocation(GP, 'str') };
    if (!COL) { COL = new Float32Array(N * 4).fill(16777215); }   // white until the photos arrive (w = exploded colour)
    if (!PE) PE = new Float32Array(N * 3);
    B.pe = buf(PE);
    B.c = buf(COL); lineBuf = gl.createBuffer();
    if (!cand) { cand = new Int32Array(K); for (var ci = 0; ci < K; ci++) cand[ci] = (Math.random() * N) | 0; }
    var R = new Float32Array(N * 4); for (var i = 0; i < R.length; i++) R[i] = Math.random();
    B.p0 = buf(shapes.logo); B.p4 = buf(shapes.vortex); B.r = buf(R);
    B.p1 = shapes.vacuum ? buf(shapes.vacuum) : B.p4; B.p2 = shapes.table ? buf(shapes.table) : B.p4; B.p3 = shapes.rack ? buf(shapes.rack) : B.p4;
    var pts = new Float32Array(S * 4), lines = new Float32Array(S * 8);
    for (var j = 0; j < S; j++) {
      var x = rnd(-1, 1), y = rnd(-1, 1), z = Math.pow(Math.random(), 3);
      pts.set([x, y, z, 0], j * 4); lines.set([x, y, z, 0, x, y, z, 1], j * 8);
    }
    starPts = buf(pts); starLines = buf(lines);
    'psz warp w wt burst time rot aspect dpr scale shift travel gain mouse hover shock mv open ofs flatm ex'.split(' ').forEach(function (n) { U[n] = gl.getUniformLocation(P, n); });
    'time dpr scroll vel'.split(' ').forEach(function (n) { SU[n] = gl.getUniformLocation(SP, n); });
    gl.enable(gl.BLEND); gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);   // premultiplied: true colours, no wash-out
  }

  /* ---------- layout, measured once (and when the page resizes) ---------- */
  var vw = 1, vh = 1, aspect = 1, dpr = 1, hTop = 0, hSpan = 1, eTop = 0, eH = 0, maxY = 1;
  function measure() {
    var nw = window.innerWidth, nh = window.innerHeight;
    if (nw !== vw || Math.abs(nh - vh) > 150 || vw === 1) {         // ignore the iOS toolbar sliding in and out
      vw = nw; vh = nh; aspect = vw / vh;
      dpr = Math.min(window.devicePixelRatio || 1, small ? 1.5 : 1.6);
      canvas.width = Math.round(vw * dpr); canvas.height = Math.round(vh * dpr);
      gl.viewport(0, 0, canvas.width, canvas.height);
    }
    var y = window.scrollY;
    if (hero) { var r = hero.getBoundingClientRect(); hTop = r.top + y; hSpan = Math.max(1, r.height - vh); }
    if (intro) { var ir = intro.getBoundingClientRect(); iTop = ir.top + y; iH = ir.height; }
    if (endEl) { var e = endEl.getBoundingClientRect(); eTop = e.top + y; eH = e.height; }
    maxY = Math.max(1, document.documentElement.scrollHeight - vh);
  }
  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  var iTop = 0, iH = 1, visT = 1, seen = 1;
  function stageAt(y) {                      // 0 logo · 1 vacuum · 2 table · 3 rack · 4 hidden · 5 logo again
    var s = 4; visT = intro || hero ? 0 : 1;   // visT: how visible the particles should be here
    if (intro) {                             // intro: the wordmark scrolls away with its section and fades
      var u = (y - iTop) / Math.max(1, iH);
      if (u < 1) { s = 0; visT = 1 - clamp01((u - .2) / .6); }
    }
    if (hero) {                              // product stories: fade in as they arrive, scroll-driven inside
      var v = Math.min(clamp01((y - hTop + vh * .7) / (vh * .7)), 1 - clamp01((y - hTop - hSpan) / (vh * .6)));
      if (v > 0 && v >= visT) {
        var h = clamp01((y - hTop) / hSpan) * 2, hi = Math.floor(h), hf = clamp01((h - hi - .5) / .32);
        s = 1 + Math.min(2, hi + hf * hf * (3 - 2 * hf)); visT = v;   // each shape holds still, then morphs
      }
    }
    if (endEl && visT < .01) {               // finale: the wordmark re-forms at the very bottom
      var a = eTop - vh, b = Math.min(eTop + eH / 2 - vh / 2, maxY), e = clamp01((y - a) / Math.max(1, b - a));
      if (e > 0) { s = 4 + e; visT = 1; }
    }
    return s;
  }

  /* ---------- input ---------- */
  var rY = 0, vY = 0, rX = 0, vX = 0, pmx = 0, pmy = 0, mvx = 0, mvy = 0, near = 0, lastShx = 0, lastShy = 0;
  var mx = 0, my = 0, tmx = 0, tmy = 0, hov = 0, thov = 0, shock = [0, 0, 9], still = 0, moved = 0;
  window.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse') return;
    tmx = e.clientX / vw * 2 - 1; tmy = 1 - e.clientY / vh * 2; thov = 1; moved = performance.now();
  }, { passive: true });
  document.addEventListener('pointerleave', function () { thov = 0; });
  window.addEventListener('pointerdown', function (e) {
    if (openSlot || (e.target.closest && e.target.closest('[data-open],.nv-how,.nv-xray')) || hitProduct(e.clientX, e.clientY)) return;
    shock[0] = e.clientX / vw * 2 - 1; shock[1] = 1 - e.clientY / vh * 2; shock[2] = 0; }, { passive: true });

  /* warp: rush toward the camera when a link is clicked; arrive from it on the next page */
  var warp = 0, warpT = 0;
  try { var navT = +sessionStorage.getItem('nvNav'); if (navT && Date.now() - navT < 4000 && !reduce) warp = 1; sessionStorage.removeItem('nvNav'); } catch (err) {}
  window.nvWarp = function (v) { if (reduce) return; warpT = v === 0 ? 0 : 1; if (v === 0) warp = 0; loop(); };

  var activeStep = -1;
  var openSlot = 0, openV = 0, lastOpen = 1, EXP = [], PE = null, exLoaded = 0;
  function setOpen(n) {
    openSlot = n;
    steps.forEach(function (el, i) {
      el.classList.toggle('is-open', i === n && n > 0);
      var how = el.querySelector('.nv-how'); if (how) how.setAttribute('aria-hidden', i === n && n > 0 ? 'false' : 'true');
      var fig = el.querySelector('.nv-xray'); if (fig) fig.setAttribute('aria-hidden', i === n && n > 0 ? 'false' : 'true');
    });
    loop();
  }
  window.nvOpen = setOpen;
  function hitProduct(x, y) {                                // is this point on the product that's on screen?
    if (!hero) return 0;
    var k = Math.round(stage); if (k < 1 || k > 3 || Math.abs(stage - k) > .25) return 0;
    if (!steps[k] || !steps[k].querySelector('.nv-how')) return 0;
    var qx = x / vw * 2 - 1, qy = 1 - y / vh * 2, dx = (qx - lastShx) * aspect, dy = qy - lastShy;
    return dx * dx + dy * dy < .3 ? k : 0;
  }
  var INSIDE = '.nv-how .nv-eyebrow,.nv-how h3,.nv-how ol,.nv-how .nv3d-row,.nv-xray img,.nv-xray figcaption';
  document.addEventListener('click', function (e) {
    var t = e.target, b = t.closest ? t.closest('[data-open]') : null;
    if (b) { var n = +b.getAttribute('data-open'); setOpen(n === openSlot ? 0 : n); return; }
    if (openSlot) { if (!(t.closest && t.closest(INSIDE))) setOpen(0); return; }   // click outside closes
    if (t.closest && t.closest('a,button,input,select,textarea,label,summary,[role=button]')) return;
    var k = hitProduct(e.clientX, e.clientY); if (k) setOpen(k);                    // clicked the product itself
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openSlot) setOpen(0); });

  function setStep(s) {
    var a = Math.min(Math.round(s), steps.length - 1);
    if (a === activeStep) return; activeStep = a;
    steps.forEach(function (el, i) { el.classList.toggle('is-on', i === a); });
  }

  /* per-stage look, interpolated */
  var SHX = [0, .34, .34, .34, 0, 0], SHY = [0, .3, .3, .3, 0, 0], SC = [1, .95, .95, .9, 1, .92],
      GA = [1, 1, 1, 1, 0, 1], AX = [0, -.06, -.06, -.06, -.1, 0], SW = [.16, .5, .5, .5, 0, .16], PZ = [1, 1.85, 1.85, 1.85, 1, 1];
  function lerpA(arr, s) { var i = Math.min(Math.floor(s), arr.length - 2), f = s - i; f = f * f * (3 - 2 * f); return arr[i] + (arr[i + 1] - arr[i]) * f; }

  var w = [0, 0, 0, 0, 0, 0], sumDt = 0, rot = new Float32Array(9), stage = 0, sY = 0, lastY = 0, vel = 0, last = 0, ema = 0, minDt = 1, frames = 0, count = N, raf = 0;
  function frame(now) {
    raf = 0; if (!P) return;
    var dt = last ? Math.min((now - last) / 1000, .05) : 1 / 60; last = now;
    var time = now / 1000;
    var y = window.scrollY;
    var damp = 1 - Math.exp(-dt * 9);       // time-based easing: same feel at any refresh rate
    var target = reduce ? Math.round(stageAt(y)) : stageAt(y);
    seen += (visT - seen) * (1 - Math.exp(-dt * 10));
    if (seen < .03) stage = target;                                    // switch shapes only while nothing is visible
    else stage += (target - stage) * (reduce ? 1 : damp);
    sY += (y - sY) * (1 - Math.exp(-dt * 16));
    var v = (y - lastY) / Math.max(dt, .001) / vh; lastY = y;
    vel += (v - vel) * (1 - Math.exp(-dt * 8));
    mx += (tmx - mx) * (1 - Math.exp(-dt * 6)); my += (tmy - my) * (1 - Math.exp(-dt * 6));
    hov += (thov - hov) * (1 - Math.exp(-dt * 4));
    var stillT = now - moved > 220 ? 1 : .25;                         // gather slowly while the mouse rests
    still += (stillT - still) * (1 - Math.exp(-dt * (stillT > still ? .7 : 4)));
    shock[2] += dt;
    warp += (warpT - warp) * (1 - Math.exp(-dt * (warpT > warp ? 6 : 1.7)));
    setStep(stage);

    // adaptive quality: if frames run long for a full second, draw fewer particles
    frames++; if (frames <= 90 && count === N) { sumDt += dt; minDt = sumDt / frames; }
    ema += (dt - ema) * .05;
    if (frames > 120 && ema > minDt * 1.45 && count > N * .45) { count = Math.round(count * .82); frames = 90; ema = minDt; }

    var prod = stage < 1 ? stage : stage > 3 ? Math.max(0, 4 - stage) : 1;   // 1 while a product is on screen
    var vis = touch ? 0 : hov * Math.min(1, lerpA(GA, stage));
    var cdx = (mx - lastShx) * aspect, cdy = my - lastShy;
    near += (vis * Math.exp(-(cdx * cdx + cdy * cdy) * 1.6) - near) * (1 - Math.exp(-dt * 5));   // how close the cursor is to the product
    var svx = (mx - pmx) / Math.max(dt, .001), svy = (my - pmy) / Math.max(dt, .001); pmx = mx; pmy = my;
    mvx += (svx - mvx) * (1 - Math.exp(-dt * 10)); mvy += (svy - mvy) * (1 - Math.exp(-dt * 10));
    var ml = Math.sqrt(mvx * mvx + mvy * mvy); if (ml > 3) { mvx *= 3 / ml; mvy *= 3 / ml; }
    var tY = Math.sin(time * .42) * lerpA(SW, stage) * (1 - near * .6) + (mx - lastShx) * (.25 + .6 * near);
    if (openSlot && Math.abs(stage - openSlot) > .35) setOpen(0);          // scrolled away: close
    openV += ((openSlot ? 1 : 0) - openV) * (1 - Math.exp(-dt * 3.2));
    var hot = !touch && near > .45 && Math.abs(stage - Math.round(stage)) < .25 && Math.round(stage) >= 1 && Math.round(stage) <= 3;
    if (hot !== html.classList.contains('nv-pointer')) html.classList.toggle('nv-pointer', hot);
    if (openSlot) lastOpen = openSlot;
    var exOn = exLoaded && exLoaded === lastOpen ? 1 : 0;
    var tX = lerpA(AX, stage) + Math.sin(time * .31) * .07 * prod * (1 - near * .6) - (my - lastShy) * (.12 + .4 * near);
    var sdt = Math.min(dt, .033);                                   // damped spring: quick, with a soft settle
    vY += (38 * (tY - rY) - 8.5 * vY) * sdt; rY += vY * sdt;
    vX += (38 * (tX - rX) - 8.5 * vX) * sdt; rX += vX * sdt;
    if (reduce) { rY = tY; rX = tX; }
    var ay = rY, ax = rX;
    var cy = Math.cos(ay), sy = Math.sin(ay), cx = Math.cos(ax), sx = Math.sin(ax);
    rot[0] = cy; rot[1] = sx * sy; rot[2] = -cx * sy; rot[3] = 0; rot[4] = cx; rot[5] = sx; rot[6] = sy; rot[7] = -sx * cy; rot[8] = cx * cy;

    var i = Math.floor(stage), f = stage - i, e = f * f * (3 - 2 * f); w[0] = w[1] = w[2] = w[3] = w[4] = w[5] = 0;
    w[Math.min(i, 5)] = 1 - e; if (i + 1 <= 5) w[i + 1] += e;
    var wide = aspect > 1.05, shx = wide ? lerpA(SHX, stage) : 0, shy = wide ? .02 * lerpA(SHX, stage) : lerpA(SHY, stage);
    shy += Math.sin(time * .9) * .018 * prod * (1 - near * .5);                // float
    shx += (mx - shx) * near * .05; shy += (my - shy) * near * .05;            // drift a touch toward the cursor
    lastShx = shx; lastShy = shy;
    if (intro && stage < 1) shy += (1 - stage) * (1 - ((iTop + iH * .4 - sY) / vh) * 2);   // the wordmark rides with the intro
    if (endEl && stage > 4) shy += (stage - 4) * (1 - ((eTop + eH / 2 - sY) / vh) * 2);   // lock the wordmark to the end section

    gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT);
    gl.useProgram(SP);
    gl.uniform1f(SU.time, time); gl.uniform1f(SU.dpr, dpr); gl.uniform1f(SU.scroll, sY / vh * .5); gl.uniform1f(SU.vel, reduce ? 0 : vel * .5 + warp * .55);
    attr(SP, 's', starPts, 4); gl.drawArrays(gl.POINTS, 0, S);
    if (!reduce && (Math.abs(vel) > .02 || warp > .02)) { attr(SP, 's', starLines, 4); gl.drawArrays(gl.LINES, 0, S * 2); }

    var fadeK = (1 - openV * Math.min(1, prod)) * seen;                                   // opened: particles fade out, the picture fades in
    var gs = prod * Math.min(1, lerpA(GA, stage)) * .32 * fadeK;                 // soft light behind the product
    if (gs > .005) {
      var gsc = Math.min(1, aspect * .72) * lerpA(SC, stage) * (1 + openV * .25);
      gl.useProgram(GP); attr(GP, 'a', GB, 2);
      gl.uniform2f(GU.c, shx, shy); gl.uniform2f(GU.rad, .95 * gsc / aspect, .95 * gsc); gl.uniform1f(GU.str, gs);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    }
    gl.useProgram(P);
    attr(P, 'p0', B.p0, 3); attr(P, 'p1', B.p1, 3); attr(P, 'p2', B.p2, 3); attr(P, 'p3', B.p3, 3); attr(P, 'p4', B.p4, 3); attr(P, 'r', B.r, 4); attr(P, 'col', B.c, 4); attr(P, 'pe', B.pe, 3);
    gl.uniform4f(U.w, w[0] + w[5], w[1], w[2], w[3]); gl.uniform1f(U.wt, w[4]);
    var bs = Math.sin(Math.PI * f); gl.uniform1f(U.burst, reduce ? 0 : bs * bs * .9);
    gl.uniform1f(U.time, reduce ? 0 : time); gl.uniformMatrix3fv(U.rot, false, rot);
    gl.uniform1f(U.aspect, aspect); gl.uniform1f(U.dpr, dpr);
    gl.uniform1f(U.scale, Math.min(1, aspect * .72) * lerpA(SC, stage) * (1 + Math.sin(time * .7) * .012 * prod) * (1 + near * .035)); gl.uniform2f(U.shift, shx, shy);
    gl.uniform1f(U.travel, reduce ? 0 : sY / vh * 1.1 + time * .12); gl.uniform1f(U.gain, lerpA(GA, stage) * fadeK + warp * .4); gl.uniform1f(U.warp, warp); gl.uniform1f(U.psz, lerpA(PZ, stage));
    var pullK = touch ? 0 : hov * still * Math.min(1, lerpA(GA, stage)) * seen;
    gl.uniform2f(U.mouse, mx, my); gl.uniform1f(U.hover, pullK); gl.uniform3f(U.shock, shock[0], shock[1], reduce ? 9 : shock[2]); gl.uniform3f(U.mv, mvx, mvy, reduce ? 0 : vis); gl.uniform1f(U.open, 0); gl.uniform1f(U.ex, 0); gl.uniform1f(U.flatm, 0); gl.uniform3f(U.ofs, 0, 0, 0);
    if (lerpA(GA, stage) * fadeK + warp > .01) gl.drawArrays(gl.POINTS, 0, count);   // nothing to draw between hero and finale
    if (pullK > .03 && openV < .05) drawLinks(pullK, shx, shy);
    if (!reduce && !document.hidden) loop();
  }
  var nearI = new Int32Array(16), nearD = new Float32Array(16), nx = new Float32Array(16), ny = new Float32Array(16);
  function drawLinks(k, shx, shy) {
    var A = [shapes.logo, CPU[1], CPU[2], CPU[3]], wa = [w[0] + w[5], w[1], w[2], w[3]];
    var sc = Math.min(1, aspect * .72) * lerpA(SC, stage), n = 0, R = .34, i, j;
    for (i = 0; i < K; i++) {
      var id = cand[i] * 3, x = 0, y = 0, z = 0;
      for (j = 0; j < 4; j++) if (wa[j] > .001 && A[j]) { x += A[j][id] * wa[j]; y += A[j][id + 1] * wa[j]; z += A[j][id + 2] * wa[j]; }
      var X = (rot[0] * x + rot[3] * y + rot[6] * z) * sc, Y = (rot[1] * x + rot[4] * y + rot[7] * z) * sc, Z = (rot[2] * x + rot[5] * y + rot[8] * z) * sc + 7;
      var qx = X / (Z * .36 * aspect) + shx, qy = Y / (Z * .36) + shy, dx = (mx - qx) * aspect, dy = my - qy, d2 = dx * dx + dy * dy;
      var pull = k * Math.exp(-d2 * 9); qx += (mx - qx) * pull * .32; qy += (my - qy) * pull * .32;
      dx = (mx - qx) * aspect; dy = my - qy; var d = Math.sqrt(dx * dx + dy * dy);
      if (d > R) continue;
      var slot = n < 16 ? n++ : -1;
      if (slot < 0) { var far = 0; for (j = 1; j < 16; j++) if (nearD[j] > nearD[far]) far = j; if (d >= nearD[far]) continue; slot = far; }
      nearD[slot] = d; nx[slot] = qx; ny[slot] = qy;
    }
    var show = Math.min(n, Math.ceil(k * 16)), m = 0;
    for (i = 0; i < show && m < LMAX; i++) {                         // cursor → dot
      var a = Math.min(1, (1 - nearD[i] / R) * k * 1.1);
      lineData.set([mx, my, a, nx[i], ny[i], a * .6], m * 6); m++;
    }
    for (i = 0; i < show && m < LMAX; i++) for (j = i + 1; j < show && m < LMAX; j++) {   // dot ↔ dot
      var ex = (nx[i] - nx[j]) * aspect, ey = ny[i] - ny[j], e = Math.sqrt(ex * ex + ey * ey);
      if (e < .12) { var b = (1 - e / .12) * k * .7; lineData.set([nx[i], ny[i], b, nx[j], ny[j], b], m * 6); m++; }
    }
    if (!m) return;
    gl.useProgram(LP); gl.bindBuffer(gl.ARRAY_BUFFER, lineBuf); gl.bufferData(gl.ARRAY_BUFFER, lineData.subarray(0, m * 6), gl.DYNAMIC_DRAW);
    var l = LOC.Ll; if (l === undefined) l = LOC.Ll = gl.getAttribLocation(LP, 'l');
    gl.enableVertexAttribArray(l); gl.vertexAttribPointer(l, 3, gl.FLOAT, false, 0, 0); gl.drawArrays(gl.LINES, 0, m * 2);
  }
  function loop() { if (!raf) raf = requestAnimationFrame(frame); }
  document.addEventListener('visibilitychange', function () { last = 0; if (!document.hidden) loop(); });
  if (reduce) window.addEventListener('scroll', loop, { passive: true });
  window.addEventListener('resize', function () { small = Math.min(window.innerWidth, window.innerHeight) < 700; measure(); loop(); });
  if ('ResizeObserver' in window) new ResizeObserver(function () { measure(); loop(); }).observe(document.body);
  document.addEventListener('shopify:section:load', function () { endEl = document.querySelector('[data-nv3d-end]'); measure(); });

  var fam = (hero && getComputedStyle(hero).getPropertyValue('--nv3d-font').trim()) || 'Anton, Impact, sans-serif';
  var ready = document.fonts && document.fonts.load ? document.fonts.load('300px ' + fam) : Promise.resolve();
  function fail() { html.classList.add('nv-nogl'); html.classList.remove('nv-gl'); if (hero) hero.classList.add('nv3d-off'); if (canvas.parentNode) canvas.parentNode.removeChild(canvas); }
  canvas.addEventListener('webglcontextlost', function (e) { e.preventDefault(); if (raf) cancelAnimationFrame(raf); raf = 0; P = null; });
  canvas.addEventListener('webglcontextrestored', function () { LOC = {}; try { setup(fam); loop(); } catch (err) { fail(); } });
  var built = buildShapes(hero ? ['vacuum', 'table', 'rack', 'vortex'] : ['vortex']);
  Promise.all([built, ready.catch(function () {})]).then(function (r) {
    shapes = r[0]; shapes.logo = logo(fam);
    CPU = [null, shapes.vacuum, shapes.table, shapes.rack];
    try { setup(fam); } catch (err) { fail(); return; }
    measure(); stage = stageAt(window.scrollY); sY = lastY = window.scrollY;
    html.classList.add('nv-gl'); if (hero) hero.classList.add('nv3d-ready'); loop();
    pending.forEach(function (a) { applyPhoto.apply(null, a); }); pending = null;
  });
  var pending = [];
  function applyPhoto(slot, pos, col, kind) {
      if (pending) { pending.push([slot, pos, col, kind]); return; }
      if (!P) return;
      if (kind === 'open') return;
      CPU[slot] = pos; var key = 'p' + slot;
      if (B[key] === B.p4) B[key] = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, B[key]); gl.bufferData(gl.ARRAY_BUFFER, pos, gl.STATIC_DRAW);
      for (var i = 0; i < N; i++) COL[i * 4 + slot - 1] = col[i];
      gl.bindBuffer(gl.ARRAY_BUFFER, B.c); gl.bufferData(gl.ARRAY_BUFFER, COL, gl.STATIC_DRAW);
      loop();
  }
  if (hero) loadPhotos(applyPhoto);
})();

